import { render, staticRenderFns } from "./BannerPhone.vue?vue&type=template&id=3bd3e4f7&scoped=true&"
import script from "./BannerPhone.vue?vue&type=script&lang=js&"
export * from "./BannerPhone.vue?vue&type=script&lang=js&"
import style1 from "./BannerPhone.vue?vue&type=style&index=1&id=3bd3e4f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd3e4f7",
  null
  
)

export default component.exports